import { QC_FILTER_PARAM_KEYS } from '@/pages/qc/utils';

import type { SavedViewsPageConfig } from './types';

/**
 * Metadata filters (`metadata.<key>=<value>`) are shipping to both pages using
 * the same convention, so both configs carry the prefix from the start — a view
 * captures them the day they land, with no code change.
 */
const METADATA_PREFIX = 'metadata.';

/**
 * Analytics filter params. Mirrors useAnalyticsFiltersState + useAgentsTabFiltersState.
 * `page` is intentionally excluded — pagination position is not part of a "view".
 */
export const ANALYTICS_SAVED_VIEWS_CONFIG: SavedViewsPageConfig = {
  pageKey: 'analytics',
  filterParamKeys: [
    'tab',
    'program_ids',
    'call_directions',
    'start',
    'end',
    'agent_ids',
    'quick',
    'sort_by',
    'sort_order',
    'page_size',
  ],
  filterParamPrefixes: [METADATA_PREFIX],
};

/**
 * AE / PQC analytics filter params. Mirrors useCasesAnalyticsFiltersState.
 */
export const CASES_ANALYTICS_SAVED_VIEWS_CONFIG: SavedViewsPageConfig = {
  // Historical localStorage namespace — the route moved to /cases-analytics, but renaming this key would orphan saved views.
  pageKey: 'aepqc-analytics',
  filterParamKeys: ['program_ids', 'report_types', 'sla_status', 'start', 'end'],
  filterParamPrefixes: [],
};

/**
 * QC filter params — derived from QC's own QC_FILTER_PARAM_KEYS so the two never
 * drift when a filter is added. That set already excludes `page`. Plus the
 * metadata prefix.
 */
export const QC_SAVED_VIEWS_CONFIG: SavedViewsPageConfig = {
  pageKey: 'qc',
  filterParamKeys: [...QC_FILTER_PARAM_KEYS],
  filterParamPrefixes: [METADATA_PREFIX],
};
